<div class="spinner-container">
  <div class="spinner"></div>
  <div class="loading-text">{{ accion }}</div>
  <p><strong>Titulo:</strong>{{ valDos }}</p>
  <p><strong>LoId:</strong>{{ valUno }}</p>
</div>
